import type { WNewsletterTranslations } from "./pl";

export const en: WNewsletterTranslations = {
  noConfig: "No newsletter window configuration data.",
  noCatalog:
    "The newsletter window has no subscription page assigned. Configure the linked catalog in the administration panel.",

  info: "Receive information from us!",
  typeEmail: "enter your e-mail address",
  save: "Sign up",

  closeLabel: "Close",

  validation: {
    requiredEmail: "Please enter your e-mail address.",
    invalidEmail: "Invalid e-mail address.",
    requiredConsent: "Consent to the processing of personal data is required.",
  },
};
